import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { assert } from '@ember/debug';
import { isNone } from '@ember/utils';
import type Owner from '@ember/owner';
import type IntlService from 'ember-intl/services/intl';

export interface AditoolsHelpTooltipSignature {
  Element: HTMLButtonElement;
  Args: {
    title: string;
    message: string;
    tooltip?: string;
    qaName?: string;
    close?: () => void;
    closeButtonText?: string;
    dialogClass?: string;
  };
  Blocks: {
    default: [];
  };
}
type AditoolsHelpTooltipArgs = AditoolsHelpTooltipSignature['Args'];
export default class AditoolsHelpTooltip extends Component<AditoolsHelpTooltipSignature> {
  @service declare intl: IntlService;

  @tracked tooltipModalEnabled = false;

  constructor(owner: Owner, args: AditoolsHelpTooltipArgs) {
    super(owner, args);
    assert('`title` is required', !isNone(this.args.title));
    assert('`message` is required', !isNone(this.args.message));
  }

  get _closeButtonText() {
    return this.args.closeButtonText ?? this.intl.t('ember-aditools-page.common.cancel');
  }

  get _tooltip() {
    return this.args.tooltip ?? this.intl.t('ember-aditools-page.card.help-tooltip');
  }

  get qaTooltipName() {
    return this.args.qaName ?? 'unnamed';
  }

  @action showTooltipClick() {
    this.tooltipModalEnabled = true;
  }

  @action showTooltipClose(close?: () => void) {
    if (typeof close === 'function') {
      close();
    }
    this.tooltipModalEnabled = false;
  }
}
